import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { useNotificationActions } from "~/shared/hooks/use-notifications.ts";
import { routingGuideEnumsSchema } from "~/shared/schemas/routing-guide-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidateTraxAr } from "~/shared/services/api/fetch-client.ts";

const getRoutingGuideEnums = async (signal?: AbortSignal) => {
	const signalOptions = signal ? { signal } : undefined;
	const url = apiRoutes.GETROUTINGGUIDEENUMS;
	const resp = await getAndValidateTraxAr(
		url,
		routingGuideEnumsSchema,
		signalOptions,
	);

	if (resp.success) {
		return resp.data;
	} else {
		throw new Error(`Failed to fetch routing guide enums: ${resp.error}`);
	}
};

export const useGetRoutingGuideEnums = () => {
	const { showError } = useNotificationActions();
	const {
		data: routingGuideEnums,
		error: routingGuideEnumsError,
		isLoading: routingGuideEnumsIsLoading,
		isFetching: routingGuideEnumsIsFetching,
		refetch: refetchRoutingGuideEnums,
	} = useQuery({
		queryKey: ["routingGuideEnums"],
		queryFn: async ({ signal }: { signal: AbortSignal }) =>
			getRoutingGuideEnums(signal),
		staleTime: Infinity,
		throwOnError: false,
	});

	useEffect(() => {
		if (routingGuideEnumsError) {
			showError(`${routingGuideEnumsError.message}`);
		}
	}, [routingGuideEnumsError, showError]);

	return {
		routingGuideEnums,
		routingGuideEnumsError,
		routingGuideEnumsIsLoading,
		routingGuideEnumsIsFetching,
		refetchRoutingGuideEnums,
	};
};
